module.exports = __webpack_public_path__ + "img/checkbox-circle-line.d2632d1f.svg";